import { defineComponent as h, useModel as v, ref as $, onMounted as b, createElementBlock as t, openBlock as s, mergeProps as f, unref as c, createElementVNode as a, renderSlot as n, createCommentVNode as l, withDirectives as w, vModelDynamic as _, toDisplayString as k } from "vue";
import { useBindCx as y } from "@scalar/use-hooks/useBindCx";
const g = { class: "flex flex-1 relative" }, V = {
  key: 0,
  class: "select-none whitespace-nowrap text-sm text-transparent"
}, C = {
  key: 1,
  class: "absolute inset-0 select-none overflow-hidden whitespace-nowrap text-sm"
}, M = {
  key: 0,
  class: "text-c-2"
}, B = { class: "text-transparent" }, D = {
  key: 1,
  class: "text-c-2"
}, S = {}, N = /* @__PURE__ */ h({
  ...S,
  inheritAttrs: !1,
  __name: "ScalarTextInput",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(m) {
    const r = v(m, "modelValue"), i = $(), { classCx: x, otherAttrs: u } = y();
    return b(() => {
      var e;
      "autofocus" in u.value && ((e = i.value) == null || e.focus());
    }), (e, o) => (s(), t("div", f(
      c(x)(
        "bg-b-1.5 flex cursor-text items-center gap-0.75 rounded-md border px-3 py-2.5 outline-offset-[-1px] focus-within:bg-b-1 has-[input:focus-visible]:outline"
      ),
      {
        onClick: o[1] || (o[1] = (p) => {
          var d;
          return (d = i.value) == null ? void 0 : d.focus();
        })
      }
    ), [
      a("div", g, [
        e.$slots.prefix ? (s(), t("span", V, [
          n(e.$slots, "prefix")
        ])) : l("", !0),
        w(a("input", f({
          ref_key: "input",
          ref: i,
          "onUpdate:modelValue": o[0] || (o[0] = (p) => r.value = p),
          class: "z-1 min-w-0 flex-1 border-none bg-transparent text-sm placeholder:font-[inherit] focus-within:outline-none"
        }, c(u)), null, 16), [
          [_, r.value]
        ]),
        e.$slots.prefix || e.$slots.suffix ? (s(), t("div", C, [
          e.$slots.prefix ? (s(), t("span", M, [
            n(e.$slots, "prefix")
          ])) : l("", !0),
          a("span", B, k(r.value || e.$attrs.placeholder), 1),
          e.$slots.suffix ? (s(), t("span", D, [
            n(e.$slots, "suffix")
          ])) : l("", !0)
        ])) : l("", !0)
      ]),
      n(e.$slots, "aside")
    ], 16));
  }
});
export {
  N as default
};
